import { SupportTicketAttachment } from '@/api/queries/supportTicket'
import classes from './attachment.module.css'

export default function SupportAttachment({ file }: { file: SupportTicketAttachment }) {
  const mime = file.mime || 'image/jpeg'
  if (!/^https?:\/\//i.test(file.url)) return null
  if (mime.startsWith('image/')) {
    return <a href={file.url} target="_blank" rel="noopener noreferrer" title={file.name}>
      <img src={file.url} alt={file.name} loading="lazy" />
    </a>
  }
  const previewUrl = /^https?:\/\//i.test(file.previewUrl || '') ? file.previewUrl : file.url
  return <section className={classes.file} aria-label={`Вложение: ${file.name}`}>
    {mime.startsWith('video/') ? <video controls preload="metadata" playsInline src={file.url} aria-label={file.name} />
      : mime.startsWith('audio/') ? <audio controls preload="metadata" src={file.url} aria-label={file.name} />
        : <span className={classes.type}>{file.name.split('.').pop()?.toUpperCase() || 'ФАЙЛ'}</span>}
    <strong>{file.name}</strong>
    {typeof file.size === 'number' && <small>{(file.size / 1048576).toFixed(2)} МБ</small>}
    <div className={classes.actions}>
      <a href={previewUrl} target="_blank" rel="noopener noreferrer">Предпросмотр</a>
      <a href={file.url} download={file.name} target="_blank" rel="noopener noreferrer">Скачать</a>
    </div>
  </section>
}
